import React from "react";
import backgroundImage from "../../../assets/images/main_background.png";
import Car from "../../../assets/images/car.jpg";

import ItemImage from "../../../assets/images/game_gozine.png";
import WoodButton from "../../../assets/images/empty_wood_btn.png";
import Time from "../../../assets/images/add_time.png";
import LessBlur from "../../../assets/images/less_blur.png";
import Grid from "@material-ui/core/Grid";
import Toolbar from "../../Toolbar";
import '../../../App.scss';
import Image from "../../pageComponents/Home/Question/Image";
import CountdownProgress from "../../pageComponents/Home/Question/CountdownProgress";
import QuestionOptions from "../../pageComponents/Home/Question/QuestionOptions";
import QuestionResult from "./../../../components/pages/Home/QuestionResult";
import {withRouter} from "react-router-dom";
import axios from "axios";
import {sessionAnswerQuestion, sessionGetQuestion, sessionHelp} from "../../../Utility/Url";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import QuestionAnswer from "../../pageComponents/Home/Question/QuestionAnswer";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Result from "../../pageComponents/Home/Question/Result";
import Polygon from "../../pageComponents/Home/GiftHall/Polygon";
import HeaderBackgroundImage from "../../../assets/images/saturn.png";
import HorizontalDivider from "../../pageComponents/Home/GiftHall/HorizontalDivider";
import Button from "../../pageComponents/Settings/Free/Button";
import Treasure from "../../../assets/images/speacialDiscountTreasure.png";
import {blue} from "@material-ui/core/colors";
import {getBase64FromUrl, sleep} from "../../../Utility/Func";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import {settings} from "../../../Store/Actions/SettingsAction";
import {questionNumber} from "../../../Store/Actions/QuestionNumberAction";
import {coinType} from "../../../Store/Actions/CoinTypeVisibleAction";
import {BOTHCOINVISIBLE, GOLDENCOINVISIBLE, SILVERCOINVISIBLE} from "../../../Store/Actions/Types";
import {BottomNavigation} from "@material-ui/core";

// image x < 87 x > 12
// image y < 94 x > 6
class Question extends React.Component{
    constructor() {
        super()
        this.state= {
            appHasLoaded: false,
            imageLoaded:true,
            timeOut:false,
            // time:null,
            picoLoader:true,
            canTry:false,
            questionTimeOut:10,
            gameType:'',
            questionData: {
                    options:
                        [
                            {
                                id:1,
                                name:'پراید',
                                text:''
                            },
                            {
                                id:2,
                                name:'پیکان',
                                text:''
                            },
                            {
                                id:3,
                                name:'مینی بوس',
                                text:''
                            },
                            {
                                id:4,
                                name:'پاترول',
                                text:''
                            },
                        ]
                },
            sessionId:null,
            picoSmallLoader:false,
            answered:false,
            showDialog:false,
            dialogData:null,
            playTickAudio:true,
            currentBlur:'',
            serverBlurMax:'65',
            cssBlurMax:'35',
            imageType:'blur',
            image:{
                blur:'1',
                image:Car
            },
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor:"#343168",
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0',
                    overflowY:'hidden'
                },
            },
            try: {
                used:null,
                opacity:'1'
            },
            time:{
                text:'زمان بیشتر',
                icon:Time,
                value:'time',
                used:false,
                opacity:1
            },
            blur:{
                text:'شفافیت بیشتر',
                icon:LessBlur,
                value:'blur',
                used:false,
                opacity:1
            },
            circle:{
                used:null,
                opacity:'1'
            },
            imageContainer:{
                height:'0',
                width:'0'

            }
        }
    }
    async componentDidMount() {
        try {
            let questionState = null
            let path=localStorage.getItem('redirect')
            if (path==='/league-start/question'){
                questionState ={
                    sessionId: localStorage.getItem('sessionId'),
                    gameType: localStorage.getItem('gameType'),
                    imageType: localStorage.getItem('imageType')
                }
                localStorage.removeItem('redirect')
            }
            else
                questionState=this.props.history.location.state
            console.log(questionState)
            if (questionState===undefined){
                console.log('its null')
                this.props.history.push('/league-start')
            }
            else{
                this.props.toggleBottomNavbar()
                const {sessionId,gameType,imageType}=questionState
                // Add CoinType for display
                switch (gameType){
                    case 'special':
                        this.props.coinType(GOLDENCOINVISIBLE)
                        break
                    default: this.props.coinType(SILVERCOINVISIBLE)
                }
                this.setState({
                    imageType:imageType
                })
                this.setState({
                    sessionId:sessionId,
                    gameType:gameType
                },()=>{
                    this.fetchQuestion(sessionId)
                })
            }
        }
        catch (e){
            alert('error occur')
        }

    }
    async componentWillUnmount() {
        this.setState({
            playTickAudio:false
        },()=>{
            alert('unmountin')
            this.props.questionNumber({visible:false,count:'',type:''})
            this.props.coinType(BOTHCOINVISIBLE)
        })
    }
    imageBlurRatio=(serverBlur)=>{
        const{serverBlurMax,cssBlurMax}=this.state
        return (serverBlur*cssBlurMax)/serverBlurMax
    }
    nextQuestion=()=>{
      this.fetchQuestion(this.state.sessionId)
    }
    fetchQuestion= async(sessionId)=>{
        const {gameType,questionData,imageLoaded}=this.state
        if (!imageLoaded)
            return
        this.setState({
            playTickAudio:true,
        })
        console.log('fetching next question',sessionId,gameType,questionData)
        await sleep(500)
        if (gameType==='normal' && (questionData && questionData.qNum))
            if (questionData.qNum === 3)
                this.props.history.push(`/home/total-prizes/b`)
        this.setState({
            answered:false,
            showDialog:false,
            picoLoader:true,
        })
        await axios.post(sessionGetQuestion,{
            sessionID:sessionId,
        })
            .then(async res => {
                const {data}=res
                this.setState({
                    currentBlur:data.level
                })
                const blur=this.imageBlurRatio(data.level)
                // let image=data.imgUrl2
                let imageUrl=data.imgUrl2.replace('http','https')
                let image = await getBase64FromUrl(imageUrl)
                this.setState({
                    picoLoader:false,
                    questionData:data,
                    image:{
                        blur:blur,
                        level:data.level,
                        imageType:this.state.imageType,
                        image:image
                    },
                    questionTimeOut:data.sec,


                },()=>{
                    this.setState({
                        imageContainer:{
                            height:document.getElementById('image-container').clientHeight,
                            width:document.getElementById('image-container').clientWidth,
                        }
                    })
                })
                const questionState=this.props.history.location.state

                const {sessionId,gameType}=questionState

                this.props.questionNumber({visible:true,count:data.qNum-1,type:gameType})
                console.log(this.props)
                }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    handleDone =async (state)=>{
        this.setState({
            timeOut:true,
        })
        await this.submitAnswer()
    }
    checkAnswered=()=>{
        if (this.state.answered)
            return true
        else return false
    }
    // answered=()=>{
    //     this.setState({
    //         answered:true,
    //         showDialog:true,
    //
    //     })
    // }
    submitAnswer=async (question= {id:''} )=>{
        this.setState({
            playTickAudio:false
        },async ()=>{
            this.setState((state, props)=>({
                // questionTimeOut:state.questionTimeOut+50,
                picoSmallLoader:true,
            }))
            await axios.post(sessionAnswerQuestion,{
                sessionID:this.state.sessionId,
                answerID:question.id
            })
                .then(res => {
                    this.setState({
                        picoSmallLoader:false
                    })
                    const {data}=res
                    if (!data.success)
                        question=this.state.questionData.options.find( ({ id }) => id === data.answerID );
                    this.setState({
                        dialogData: {
                            question:question,
                            data:data,
                            image:{
                                blur:'0',
                                image:this.state.image.image
                            },
                            canTry:data.try.isValid
                            // image:this.state.image
                        },
                        answered:true,
                        showDialog:true,

                    })
                }).catch(error=>{
                        console.log(error.toString())
                    }
                )
        })

    }
    getHelp=async (data)=>{
        const helpType=data.value
        this.setState({ [helpType]: { ...this.state[helpType], used: true,opacity:0.5} });
        await axios.post(sessionHelp,{
            sessionID:this.state.sessionId,
            type:helpType
        })
            .then(res => {
                console.log(res)
                const {data}=res

                if (data.success){
                    // const {data}=res
                    if (helpType==='time'){
                        const temp =this.state.questionData.helps
                        const result = temp.find( ({ key }) => key === 'time' );
                        this.setState({
                            questionTimeOut:this.state.questionTimeOut+result.value,
                        })
                    }
                    else if (helpType==='blur'){
                        const temp =this.state.questionData.helps
                        const result = temp.find( ({ key }) => key === 'blur' );
                        const blur=this.imageBlurRatio(result.value)
                        this.setState({ image: { ...this.state.image, blur:blur} });
                    }
                    // const blur=this.imageBlurRatio(data.level)
                    // this.setState({
                    //     picoLoader:false,
                    //     questionData:data,
                    //     image:{
                    //         blur:blur,
                    //         // blur:'1',
                    //         image:data.imgUrl2
                    //     },
                    // })
                }

            }).catch(error=>{
                    console.log(error.toString())
                }
            )

    }
    render() {
        // let image= {
        //         blur:'5',
        //         image:Car
        //     }
        const {imageContainer,blur,time,questionTimeOut,picoLoader,questionData,picoSmallLoader,answered,dialogData,image,playTickAudio,gameType,timeOut}=this.state
        const hallButton={
            text:'برو به تالار',
            backgroundColor:'gray',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'#000000'
        }
        const polygon= {
            icon: Treasure,
            text: '6',
            textColor: 'yellow',
            locked: false,
            hasGlowBackground: false,
        }
        const badge={
            conditionValue:20
        }
        const options=[
            time,
            blur
        ]
        // if (questionData){
        //     // image={
        //     //     blur:'1',
        //     //     image:questionData.imgUrl2
        //     // }
        let answers=''
        try {
            answers=questionData.options.map(data=>{
                return{
                    id:data.id,
                    text:data.text
                }
            })
        }catch (e) {
            this.props.history.push('/league-start')
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        return(
            <Grid style={this.state.style.root} direction={"column"} item container>
                {
                    (!picoLoader ) &&
                    <Grid item sm={12} justify={'center'} container direction={"column"} style={{flex:'1',minHeight:'0'}}>
                        <Grid item container id={"TTT"}>
                            <Toolbar type='sideToolbar'/>
                        </Grid>
                        {
                            (!answered) &&
                            <Grid item container xs={12} justify={"center"} sm={12} className='scrollBar'
                                  style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                                <Grid id='image-container' container style={{backgroundColor:'',borderRadius:'30px',overflow:'hidden'}} item sm={11} xs={11} justify={"center"} alignItems={"center"}>
                                    <Image size ={imageContainer} data={image} speed={questionData.speed}/>
                                </Grid>
                                {
                                    (Array.isArray(answers))&&
                                    <Grid container item sm={11} xs={11} justify={"space-between"}>
                                        <Grid container item sm={10} xs={10} alignItems={"center"} justify={"center"}>
                                            {
                                                answers.map(data=>{
                                                    return(<Grid item sm={12} xs={12} container justify={"center"}
                                                                 alignItems={"center"}
                                                                 onClick={(e)=>{
                                                                     // this.answered()
                                                                     this.submitAnswer(data)
                                                                     // this.props.history.push('/home/question-result')
                                                                 }}
                                                    >
                                                        <QuestionAnswer checkAnswered={this.checkAnswered} data={data}/>
                                                    </Grid>)
                                                })
                                            }
                                            {
                                                !picoSmallLoader &&
                                                <Grid item sm={10} xs={10} container justify={"space-around"} alignItems={"center"}
                                                      style={{
                                                          backgroundImage: "url(" + WoodButton + ")",
                                                          backgroundSize: '100% 100%',
                                                          backgroundRepeat: 'no-repeat',
                                                          // height:'100px'
                                                          padding:'20px 0'
                                                      }}
                                                >
                                                    {
                                                        options.map(data=>{
                                                            return(
                                                                <Grid item container sm={5} xs={5}
                                                                      className={data.used?'':'clickable'}
                                                                      style={{
                                                                          opacity:data.opacity
                                                                      }}
                                                                      onClick={()=>{
                                                                          this.getHelp(data)
                                                                      }}
                                                                >
                                                                    <QuestionOptions data={data}/>
                                                                </Grid>
                                                            )
                                                        })
                                                    }
                                                </Grid>
                                            }
                                            {
                                                picoSmallLoader &&
                                                <Grid sm={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                                      style={{position:'relative',height:'50px'}}
                                                >
                                                    <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                                        <PicoLoader/>
                                                    </Grid>
                                                </Grid>
                                            }

                                        </Grid>
                                        <Grid container direction={"column"} item sm={2} xs={2} alignItems={"center"} justify={"center"}>
                                            <CountdownProgress timeOut={questionTimeOut} done={this.handleDone} data={playTickAudio}/>
                                        </Grid>
                                    </Grid>
                                }

                            </Grid>
                        }
                        {
                            answered &&
                            <Grid item alignItems={"flex-end"} container xs={12} justify={"space-between"} sm={12} className='scrollBar'
                                  style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                                <Dialog
                                        open={this.state.showDialog}
                                        disableBackdropClick
                                        onClose={handleClose}
                                        aria-labelledby="alert-dialog-title"
                                        aria-describedby="alert-dialog-description"
                                        style={{background:'red !important'}}
                                        PaperProps={{
                                            style: {
                                                backgroundColor: 'transparent',
                                                boxShadow: 'none',
                                            },
                                        }}
                                    >
                                        <DialogContent style={{display:'flex',alignItems:'center'}}>
                                            <Result timeOut={timeOut} questionNumber={this.props.QuestionNumber.data.count} sessionId={this.state.sessionId} nextQuestion={this.nextQuestion} imageType={this.state.imageType} gameType={gameType} data={dialogData}/>
                                        </DialogContent>
                                    </Dialog>
                                {/*{*/}
                                {/*        gameType!=='normal' &&*/}
                                {/*        <Grid item className='question-result-bottom-section' alignItems={"center"} container justify={"center"}*/}
                                {/*                    style={{*/}
                                {/*                        zIndex:1301*/}
                                {/*                    }}*/}
                                {/*        >*/}
                                {/*            <Grid container alignItems={"center"} item sm={3} xs={3} style={{position:'absolute',top:'-65%',zIndex:'10'}}>*/}
                                {/*                <Polygon data={polygon}/>*/}
                                {/*            </Grid>*/}
                                {/*            <Grid justify={"space-around"} alignItems={"center"} container style={{*/}
                                {/*                backgroundImage:`url(${HeaderBackgroundImage})`,*/}
                                {/*            }}*/}
                                {/*                  className='question-result-bottom-section'*/}
                                {/*            >*/}
                                {/*                <Grid item sm={5} xs={5} style={{height:'50px'}}>*/}
                                {/*                    <HorizontalDivider data={badge}/>*/}
                                {/*                </Grid>*/}
                                {/*                <Grid container alignItems={"center"} item sm={3} xs={3} style={{height:'70px'}}>*/}
                                {/*                    {*/}
                                {/*                        this.state.type===true &&*/}
                                {/*                        <p style={{textAlign:'center',fontSize:'20px'}}>*/}
                                {/*                            19 سوال دیگه باید جواب بدی*/}
                                {/*                        </p>*/}
                                {/*                    }*/}
                                {/*                    {*/}
                                {/*                        this.state.type !== true &&*/}
                                {/*                        <Button data={hallButton}/>*/}
                                {/*                    }*/}
                                {/*                </Grid>*/}
                                {/*            </Grid>*/}
                                {/*        </Grid>*/}
                                {/*}*/}

                            </Grid>
                        }
                    </Grid>
                }
                {
                    picoLoader &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const QS=withRouter (Question)
const mapStateToProps=state=>({
    QuestionNumber:state.QuestionNumber,
    CoinType:state.CoinTypeVisible
})
export default connect(mapStateToProps,{questionNumber,coinType}) (QS)
